import { combineReducers } from 'redux';
import multireducer from 'multireducer';
import routing from './routing';
import {reducer as reduxAsyncConnect} from 'redux-connect';
import { loadingBarReducer } from 'react-redux-loading-bar';
import {reducer as modalReducer} from 'react-redux-modal'

import auth from './auth';
import counter from './counter';
import {reducer as form} from 'redux-form';
import info from './info';
import widgets from './widgets';
import clients from './clients';
import fiches from './fiches';
import groups from './groups';
import users from './users';
import modules from './modules';
import supervision from './supervision';
import sessions from './sessions';
import errors from './errors';
import csv from './csv';
import products from './products';
import tickets from './tickets';
import history from './history';
import timelineEvents from './timelineEvents';
import supervisionErrors from './supervisionErrors';

import lastEvents from './lastEvents';

import equipsnSync from './equipsnSync';


import commercial from './commercial';

import { reducer as idle } from '../../components/redux-idle-monitor'


const appReducer = combineReducers({
  routing,
  reduxAsyncConnect,
  auth,
  form,
  clients,
  fiches,
  groups,
  users,
  modules,
  supervision,
  supervisionErrors,
  sessions,
  errors,
  loadingBar:loadingBarReducer,
  modals: modalReducer,
  csv,
  products,
  tickets,
  history,
  timelineEvents,
  idle,
  commercial,
  lastEvents,
  equipsnSync

});

const rootReducer = (state, action) => {
	if (action.type === 'server-sts/auth/LOGOUT_SUCCESS') {
		const { routing } = state
		
		state = undefined;

	}
  return appReducer(state, action)
}

export default rootReducer;
 